import { Button, styled } from '@mui/material';

export default styled(Button)({
  paddingLeft: 24,
  paddingRight: 24,
  height: 64,
});
